import React from 'react';
import Login from '../Login/Login';

const action = props => {
  return <Login {...props} />;
};

export default action;
